import { render } from "./ProductReviews.vue?vue&type=template&id=0bac2594&scoped=true"
import script from "./ProductReviews.vue?vue&type=script&lang=js"
export * from "./ProductReviews.vue?vue&type=script&lang=js"

import "./ProductReviews.vue?vue&type=style&index=0&id=0bac2594&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bac2594"]])

export default __exports__